import { render, staticRenderFns } from "./salesTableFw.vue?vue&type=template&id=7b8d5a16&scoped=true"
import script from "./salesTableFw.vue?vue&type=script&lang=js"
export * from "./salesTableFw.vue?vue&type=script&lang=js"
import style0 from "./salesTableFw.vue?vue&type=style&index=0&id=7b8d5a16&prod&scoped=true&lang=css"
import style1 from "./salesTableFw.vue?vue&type=style&index=1&id=7b8d5a16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8d5a16",
  null
  
)

export default component.exports